import _asyncToGenerator from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/root/code/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { setUserId } from "@snowplow/browser-tracker";
import loggy from "@catchoftheday/loggy";
export function spContext(_x) {
  return _spContext.apply(this, arguments);
}

function _spContext() {
  _spContext = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(pathname) {
    var queryString,
        res,
        data,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queryString = _args.length > 1 && _args[1] !== undefined ? _args[1] : "";
            _context.prev = 1;
            _context.next = 4;
            return fetch("/sp-context".concat(pathname).concat(queryString), {
              headers: {
                Accept: "application/json"
              }
            });

          case 4:
            res = _context.sent;
            _context.next = 7;
            return res.json();

          case 7:
            data = _context.sent;

            if (data.userId) {
              setUserId(data.userId);
            }

            return _context.abrupt("return", data);

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            loggy.error(_context.t0);
            return _context.abrupt("return", null);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 12]]);
  }));
  return _spContext.apply(this, arguments);
}